export default function elmntIO(el = null) {

    if ( !el || !('io' in el.dataset) ) return;

    const ioTreshold = ( 'ioThreshold' in el.dataset ) ? parseFloat(el.dataset.ioThreshold) : 0.15;
    const ioOptions = {
        threshold: ioTreshold
    };

    let io = new IntersectionObserver(callback, ioOptions);
    io.observe(el);
}

function callback(entries) {
    entries.forEach(entry => {
        if ( 'once' == entry.target.dataset.io ) {
            handleIoOnce(entry);
        } else {
            handleIo(entry);
        }
    });
}

function handleIoOnce(entry) {
    if ( entry.isIntersecting ) {
        entry.target.dataset.ioVisible = true;
    }
}

function handleIo(entry) {
    if ( entry.isIntersecting ) {
        entry.target.dataset.ioVisible = true;
    } else {
        entry.target.dataset.ioVisible = false;
    }
}